module.exports = __webpack_public_path__ + "img/logo.442354d9.png";